import {axios} from '@/vue/utils/request'

const api = {
    monitoringAll: '/monitoring/all',
    // 报表
    getCustomerData: '/monitoring/getCustomerData',
    getApplyData: '/monitoring/getApplyData',
    getLoanData: '/monitoring/getLoanData',
    getLoanAmountData: '/monitoring/getLoanAmountData',
    getSimpleData: '/monitoring/getSimpleData',
    getLoanAmountByMonth: '/monitoring/getLoanAmountByMonth',
    getScaleData: '/monitoring/getScaleData',
    creditApi: '/monitoring/creditApi',
    getOverDueData: '/overdue/asset/list',
    getOverDueDayStatic:'/monitoring/overdue/day'
}

export function creditApi(params) {
    return axios({
        url: api.creditApi,
        method: 'post',
        data: params
    })
}
export function getScaleData(params) {
    return axios({
        url: api.getScaleData,
        method: 'get',
        params: params
    })
}

export function getLoanAmountByMonth(params) {
    return axios({
        url: api.getLoanAmountByMonth,
        method: 'get',
        params: params
    })
}

export function getSimpleData(params) {
    return axios({
        url: api.getSimpleData,
        method: 'get',
        params: params
    })
}

export function getMonitoringAll(params) {
    return axios({
        url: api.monitoringAll,
        method: 'get',
        params: params
    })
}

export function getCustomerData (params) {
    return axios({
        url: api.getCustomerData,
        method: 'get',
        params: params
    })
}

export function getApplyData (params) {
    return axios({
        url: api.getApplyData,
        method: 'get',
        params: params
    })
}

export function getLoanData (params) {
    return axios({
        url: api.getLoanData,
        method: 'get',
        params: params
    })
}

export function getLoanAmountData (params) {
    return axios({
        url: api.getLoanAmountData,
        method: 'get',
        params: params
    })
}

export function getOverDue(params) {
    return axios({
        url: api.getOverDueData,
        method: 'get',
        params: params
    })
}


export function getOverDueDayStatic(params) {
    return axios({
        url: api.getOverDueDayStatic,
        method: 'get',
        params: params
    })
}
